/*******************************************************
NBA EVENT HANDLERS
This handles events for various interactions related to NBA.
********************************************************/

import addCourtOnOffPlayer from './add-court-on-off-player';
import clearInjuryArchiveSearch from './clear-injury-archive-search';
import debounce from '../../../js/universal/debounce/debounce';
import loadCourtOnOffTable from './load-court-on-off-table';
import openCourtOnOffModal from './open-court-on-off-modal';
import openInjuryArchiveModal from './open-injury-archive-modal';
import openTeamTrendsModal from './open-team-trends-modal';
import removeCourtOnOffPlayer from './remove-court-on-off-player';
import triggerInjuryArchiveSearch from './trigger-injury-archive-search';

export default function addNBAEventHandlers() {

    $(document).on('click', '.tt-open-nba', openTeamTrendsModal);

    $(document).on('click', '.open-court-on-off-modal', openCourtOnOffModal);

    $(document).on('click', '.add-court-on-off-player', addCourtOnOffPlayer);

    $(document).on('click', '.remove-court-on-off-player', removeCourtOnOffPlayer);

    $(document).on('click', '.load-court-on-off-table', loadCourtOnOffTable);

    $(document).on('click', '.open-injury-archive-modal', openInjuryArchiveModal);

    $(document).on('keyup', '#injury-archive-search',  debounce(triggerInjuryArchiveSearch, 300));

    $(document).on('click', '.clear-injury-archive-search', clearInjuryArchiveSearch);

}
